import { useState } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-[72px] bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
      <nav className="w-full h-full px-4 md:px-6 flex items-center justify-between max-w-[1440px] mx-auto">
        <a href="#" className="flex items-center gap-2 whitespace-nowrap">
          <span className="w-9 h-9 flex items-center justify-center bg-accent-500 text-background-50 rounded-lg text-lg font-bold">60</span>
          <span className="text-xl font-heading text-foreground-950">6080电影网</span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          <a href="#" className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md transition-colors whitespace-nowrap">首页</a>
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md transition-colors whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl w-5 h-5 flex items-center justify-center`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="flex flex-col px-4 py-3 gap-1">
            <a href="#" onClick={() => setMobileOpen(false)} className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md transition-colors">首页</a>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}